import uniqueId from 'lodash/uniqueId'
import emitter from '../../mixin/emitter'

export default {
  name: 'UiFormSwitch',

  mixins: [emitter],

  inheritAttrs: false,

  inject: {
    uiFormItem: {
      default: '',
    },
  },

  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  // language=HTML (for PhpStorm)
  template: `
    <div class="switch" :class="classObject">
      <input type="checkbox" :id="id" class="switch-input" v-model="realChecked">
      <label class="switch-paddle" :for="id">
        <span class="switch-active" aria-hidden="true">{{ on }}</span>
        <span class="switch-inactive" aria-hidden="true">{{ off }}</span>
      </label>
      <template v-if="!$slots.default && label">
        <label :for="id">{{ label }}</label>
      </template>
    </div>
  `,

  props: {
    size: {
      type: String,
      default: '',
    },
    on: {
      type: String,
      default: 'Yes',
    },
    off: {
      type: String,
      default: 'No',
    },
    label: {
      type: String,
      required: false,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      id: `switch-${uniqueId()}`,
      realChecked: this.modelValue,
    }
  },

  computed: {
    classObject() {
      const classes = {}
      if (this.size) {
        classes[this.size] = true
      }
      return classes
    },
  },

  watch: {
    checked(checked) {
      this.realChecked = checked
    },
    realChecked(checked) {
      this.$emit('update:modelValue', checked)
    },
  },
}
